/**
 * Created by USER on 18/5/23.
 */
/**
 * Created by USER on 18/5/23.
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import {Input, Button, Checkbox, Icon, Collapse, Modal, message} from 'antd';
import {sha256} from 'js-sha256';
import bs58 from 'bs58';
import {Link} from 'react-router-dom';
import {changeBarState} from '../redux/actions/headerbar_action';
import {addAddress} from '../redux/actions/address_information_action';
import ImgList from '../images/img';
import httpClient from '../swagger/swagger';
import {addProduct} from '../redux/actions/payment_action';
import AgreementModal from '../component/agreement_modal';

const { client, setAccesskey } = httpClient;
const { TextArea } = Input;
const {Panel} = Collapse;

class ShoppingCart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropDownIcon: ['down', 'down', 'down'],
      verificationModal: false,
      buttonValue: this.props.t('product_cart_address_verification_button'),
      buttonDisabled: false,
      productAmount: 1,
      price: 0,
      totalPrice: 0,
      inputValue: {
        name: '', mobile: '', address: ''
      },
      notice_mobile: '',
      verification_code: '',
      agreeChecked: false,
      inputValidation: {
        name: true, mobile: true, address: true, notice_mobile: true, verification_code: true
      },
      invoice: '',
      invoiceModal: false,
      receipt_shipping_address: { // input onChange 改变的时候得到的value
        name: '',
        address: '',
        mobile: '',
        title: '个人',
        tax_no: '',
        email: ''
      },
      invoiceTitle: 'personal',
      invoiceType: 'ordinary',
      voiceChecked: false,
      voiceInputValidation: [true, true, true, true, true, true],
      agreementModal: false,
      invoiceData: { // 最终确认的值， 因为有一个取消和保存的操作
        name: '',
        address: '',
        mobile: '',
        title: '个人',
        tax_no: '',
        email: ''
      },
      FinlyInvoiceTitle: 'personal',
      FinlyInvoiceType: 'ordinary',
      webInvoiceDropIcon: 'right',
      offsetWidth: 0,
      discount: null,
      discountError: false,
      discountPrice: 0,
      discountUsed: false,
      discountButton: this.props.t('product_cart_discount_button')
    };
  }

  componentWillMount() {
    this.props.dispatch(changeBarState('product')); // 改变header的状态啊
    client.then((oclient) => { // 请求商品的详细信息
      oclient.apis.product.get_v1_product_id({
        id: 1
      }).then((res) => {
        if (res.obj.code !== 200) {
          message.error(res.obj.message);
        } else {
          this.setState({
            price: res.obj.data.price,
            totalPrice: res.obj.data.price
          });
        }
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => message.error(this.props.t('request_error')));
    this.makeToken();
  }

  componentDidMount() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500);
    this.setState({
      offsetWidth: document.body
    });
    document.addEventListener('mousedown', (e) => { // 监听机器人验证的滑动
      this.wrapperChange(e, true)
    });
    document.addEventListener('mouseup', (e) => { // 监听机器人验证的滑动
      this.wrapperChange(e, false)
    })
  }

  wrapperChange(e, isChange) { // 人机验证自定义样式的改变
    const ele = document.getElementsByClassName('btn_slide');
    if (e.target == ele[0]) {
      const backgroundEle = document.getElementsByClassName('nc-lang-cnt');
      backgroundEle[0].style.background = 'none';
      backgroundEle[0].style.webkitTextFillColor = isChange ? '#FFF' : "#4d4d4d";
    }
  }

  makeToken() { // 生成Token
    const {notice_mobile} = this.state;
    const mobileSha = sha256(sha256.digest(notice_mobile));
    const timestamp = parseInt(new Date().getTime() / 1000, 10).toString();
    const another = mobileSha.slice(timestamp.length);
    let token = '';
    for (let i = 0; i < timestamp.length; i++) {
      token += mobileSha[i] + timestamp[i];
    }
    const bytes = Buffer.from(token + another, 'hex');
    return bs58.encode(bytes);
  }

  panelChange(data) { // mobile panel change事件，icon的变化
    const {dropDownIcon} = this.state;
    dropDownIcon[0] = data.indexOf('product') >= 0 ? 'down' : 'right';
    dropDownIcon[1] = data.indexOf('address') >= 0 ? 'down' : 'right';
    dropDownIcon[2] = data.indexOf('statitics') >= 0 ? 'down' : 'right';
    this.setState({
      dropDownIcon
    });
  }

  countdown() { // 验证码倒计时
    let time = 60;
    const countdown = setInterval(() => {
      time--;
      this.setState({
        buttonValue: `${time}${this.props.t('product_cart_address_verification_button2')}`
      });
      if (time === 0) {
        clearInterval(countdown);
        this.setState({
          buttonValue: this.props.t('product_cart_address_verification_button'),
          buttonDisabled: false
        });
      }
    }, 1000);
  }

  getVerification() { // 获取验证码
    const {inputValue, inputValidation} = this.state;
    if (/^1[34578]\d{9}$/.test(inputValue.mobile.replace(/^\s+|\s+$/g, ''))) { // 判断接收验证码的手机号是否正确
      this.countdown();
      this.setState({
        buttonDisabled: true
      });
      client.then((oclient) => {
        oclient.apis.sms.post_v1_sms_send({
          mobile: inputValue.mobile
        }).then((res) => {
          if (res.obj.code !== 200) {
            message.error(res.obj.message);
          }
        }).catch(() => message.error(this.props.t('request_error')));
      }).catch(() => message.error(this.props.t('request_error')));
    } else {
      inputValidation.mobile = false;
      this.setState({
        inputValidation
      });
    }
  }

  handleCancel() { // modal的隐藏函数
    this.setState({
      verificationModal: false,
      agreementModal: false,
      invoiceModal: false
    });
  }

  deleteProduct(productAmount) { // 添加一个商品
    const {price} = this.state;
    if (productAmount > 1) {
      const amount = productAmount - 1;
      this.setState({
        productAmount: amount,
        totalPrice: price * amount
      });
    }
  }

  addProduct(productAmount) { // 删除一个商品
    const {price} = this.state;
    if (productAmount < 9999) {
      const amount = productAmount + 1;
      this.setState({
        productAmount: amount,
        totalPrice: price * amount
      });
    }
  }

  inputInformationOnchange(e, type) { // 名称输入框onchang事件
    const {inputValue, inputValidation} = this.state;
    inputValue[type] = e.target.value;
    inputValidation[type] = true;
    this.setState({
      inputValue,
      inputValidation,
    });
  }

  inputVerificationOnchange(e) { // 验证码的输入框
    let verificationCode = this.state.verification_code;
    const {inputValidation} = this.state;
    verificationCode = e.target.value;
    inputValidation.verification_code = true;
    this.setState({
      verification_code: verificationCode,
      inputValidation,
    });
  }

  inputNoticeMobileOnchange(e) { // 通知短信的输入框
    let noticeMobile = this.state.notice_mobile;
    const {inputValidation} = this.state;
    noticeMobile = e.target.value;
    inputValidation.notice_mobile = true;
    this.setState({
      notice_mobile: noticeMobile,
      inputValidation
    });
  }

  invoiceChecked(e) { // 是否需要发票
    this.setState({
      voiceChecked: e.target.checked
    });
  }

  invoiceChange() {
    this.setState({
      invoiceModal: true
    });
  }

  invoiceCancel() { // 取消发票
    this.setState({
      invoiceModal: false
    });
  }

  agreeChecked(e) { // 是否同意协议
    this.setState({
      agreeChecked: e.target.checked
    });
  }

  inputValidation(type, reg) { // 封装的基础信息input验证方法
    const {
      inputValue, inputValidationComplete, inputValidation
    } = this.state;
    return new Promise((resolve) => {
      if (!(reg.test(inputValue[type].replace(/^\s+|\s+$/g, '')))) { // 表单验证
        inputValidation[type] = false;
        this.setState({
          inputValidation,
          inputValidationComplete
        });
        resolve(false);
      } else {
        resolve(true);
      }
    });
  }

  inputValidationAnother(type, reg, value) { // 封装的其他信息的表单验证
    const {inputValidation} = this.state;
    return new Promise((resolve) => {
      if (!(reg.test(value.replace(/^\s+|\s+$/g, '')))) {
        inputValidation[type] = false;
        this.setState({
          inputValidation
        });
        resolve(false);
      } else {
        resolve(true);
      }
    });
  }

  browser() { // 判断客户端是pc还是移动端
    if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
      return 'h5';
    }
    return 'pc';
  }

  humanVerification() {
    const promise = new Promise((resolve) => { // 模态框打开之后才开始初始化人机验证的组件
      this.setState({
        verificationModal: true,
      });
      resolve(true);
    });

    promise.then(() => {
      const ncToken = ['FFFF0N00000000005FC2', (new Date()).getTime(), Math.random()].join(':'); // 初始化人机器验证
      if (this.browser() === 'h5') {
        const nc = window.NoCaptcha.init({ // h5 验证
          renderTo: '#validation',
          appkey: 'FFFF0N00000000005FC2',
          scene: 'nc_login_h5',
          token: ncToken,
          trans: {key1: 'code0'},
          elementID: ['usernameID'],
          is_Opt: 0,
          language: 'cn',
          timeout: 3000,
          retryTimes: 5,
          errorTimes: 5,
          inline: false,
          apimap: {},
          bannerHidden: false,
          initHidden: false,
          callback: (data) => {
            this.setAccesskeyAndSubmit(data, ncToken);
          },
        });
        window.NoCaptcha.setEnabled(true);
        nc.reset(); // 请务必确保这里调用一次reset()方法
        window.NoCaptcha.upLang('cn', {
          LOADING: this.props.t('captch8'), // 加载
          SLIDER_LABEL: this.props.t('captcha'), // 等待滑动
          CHECK_Y: this.props.t('captcha1'), // 通过
          ERROR_TITLE: this.props.t('captcha9'), // 拦截
          CHECK_N: this.props.t('catpcha5'), // 准备唤醒二次验证
          OVERLAY_INFORM: this.props.t('captcha10'), // 二次验证
          TIPS_TITLE: this.props.t('captcha11') // 验证码输错时的提示
        });
        nc.reload();
      } else {
        const ncOpt = // pc－web验证
          {
            renderTo: '#validation',
            appkey: 'FFFF0N00000000005FC2',
            scene: 'nc_login',
            token: ncToken,
            customWidth: 300,
            trans: {key1: 'code0'},
            elementID: ['usernameID'],
            is_Opt: 0,
            language: 'cn',
            isEnabled: true,
            timeout: 3000,
            times: 5,
            apimap: {},
            callback: (data) => {
              this.setAccesskeyAndSubmit(data, ncToken);
            }
          };
        const nc = new window.noCaptcha(ncOpt);
        nc.upLang('cn',{
          _startTEXT: this.props.t('captcha'),
          _yesTEXT: this.props.t('captcha1'),
          _error300: `${this.props.t('captcha2')}<a href=\'javascript:__nc.reset()\'>${this.props.t('captcha3')}</a>${this.props.t('captcha4')}`,
          _errorNetwork: `${this.props.t('captcha6')}<a href=\'javascript:__nc.reset()\'>${this.props.t('captcha7')}</a>`,
        });
        nc.reload();
      }
    }).catch(() => {});
  }

  setAccesskeyAndSubmit(data, ncToken) {
    this.setState({ // 人机验证通过之后 关闭模态框
      verificationModal: false,
    });
    // 设置token之后再发起下单的请求
    setAccesskey(this.makeToken()).then(() => {
      const {
        productAmount, notice_mobile, verification_code, inputValue,
        FinlyInvoiceType, voiceChecked, invoiceData, discount, discountUsed
      } = this.state;
      const obj = {
        product_id: '1',
        amount: productAmount,
        order_remark: '',
        notice_mobile,
        mobile_code: verification_code,
        product_shipping_address: inputValue,
        receipt_type_code: FinlyInvoiceType === 'electronic' ? 0 : 1,
        receipt_shipping_address: invoiceData,
        coupon_code: discount
      };
      if (!voiceChecked) {
        delete obj.receipt_type_code;
        delete obj.receipt_shipping_address;
      }
      if (!discount || !discountUsed) {
        delete obj.coupon_code;
      }
      client.then((oclient) => {
        oclient.apis.order.post_v1_order({
          json: JSON.stringify(obj),
          nc_token: ncToken,
          session_id: data.csessionid,
          sig: data.sig
        }).then((result) => {
          if (result.obj.code === 200) {
            this.props.dispatch(addProduct({order: result.obj.id, notice_mobile}));
            window.localStorage.setItem('order', JSON.stringify({order: result.obj.id, notice_mobile}))
            this.props.history.push('/product/payment');
          } else if (result.obj.code === -11101) {
            const {inputValidation} = this.state;
            inputValidation.verification_code = false;
            this.setState({
              inputValidation,
            });
            const elements = document.getElementsByClassName('input_error')[0]; // 跳至报错的地方
            window.scrollTo(0, elements.offsetTop - 20);
          } else {
            message.error(result.obj.message);
          }
        }).catch(() => message.error(this.props.t('request_error')));
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => {});
  }

  submitOrder() { // 验证表单，以及人机验证modal的打开
    const {
      agreeChecked, inputValue, verification_code, notice_mobile, productAmount
    } = this.state;
    if (agreeChecked) {
      Promise.all([this.inputValidation('name', /^.{1,16}$/),
        this.inputValidation('mobile', /^1[34578]\d{9}$/),
        this.inputValidationAnother('verification_code', /^\d{6}$/, verification_code),
        this.inputValidation('address', /^.{1,60}$/),
        this.inputValidationAnother('notice_mobile', /^1[34578]\d{9}$/, notice_mobile)
      ]).then((res) => { // 判断表单是否完全输入正确
        if (res.indexOf(false) === -1) {
          this.props.dispatch(addAddress({inputValue, notice_mobile, productAmount}));
          this.humanVerification();
        } else {
          const {dropDownIcon} = this.state;
          dropDownIcon[1] = 'down';
          this.setState({
            dropDownIcon
          });
          const elements = document.getElementsByClassName('input_error')[0]; // 跳至报错的地方
          window.scrollTo(0, elements.offsetTop - 20);
        }
      }).catch(() => {});
    }
  }

  invoiceBelong(invoiceTitle) { // 发票属于个人或公司的切换
    const {voiceInputValidation, receipt_shipping_address} = this.state;
    voiceInputValidation[0] = true;
    this.setState({
      invoiceTitle,
      voiceInputValidation
    });
    if (invoiceTitle === 'personal') {
      receipt_shipping_address.title = '个人';
      this.setState({
        receipt_shipping_address
      });
    } else {
      receipt_shipping_address.title = '';
      this.setState({
        receipt_shipping_address
      });
    }
  }
  invoiceType(invoiceType) { // 发票类型
    const {voiceInputValidation} = this.state;
    voiceInputValidation[5] = true;
    this.setState({
      invoiceType,
      voiceInputValidation
    });
  }
  invoiceInputOnChange(e, type, index) { // voice Input的onChange事件
    const {receipt_shipping_address, voiceInputValidation} = this.state;
    voiceInputValidation[index] = true;
    receipt_shipping_address[type] = e.target.value;
    this.setState({
      receipt_shipping_address,
      voiceInputValidation
    });
  }

  voiceInputValidation(type, reg) { // 表单验证
    const {receipt_shipping_address} = this.state;
    return new Promise((resolve) => {
      if (!(reg.test(receipt_shipping_address[type].replace(/^\s+|\s+$/g, '')))) {
        resolve(false);
      } else {
        resolve(true);
      }
    });
  }
  tax_noInputValidation() { // 纳税人号验证
    const {tax_no} = this.state.receipt_shipping_address;
    const taxNo = tax_no.replace(/^\s+|\s+$/g, '');
    return new Promise((resolve) => {
      if (/^[0-9A-Z]{15}$/.test(taxNo) || /^[0-9A-Z]{17}$/.test(taxNo) || /^[0-9A-Z]{18}$/.test(taxNo) || /^[0-9A-Z]{20}$/.test(taxNo)) {
        resolve(true);
      } else {
        resolve(false);
      }
    });
  }
  voiceSubmit() {
    const {invoiceType} = this.state;
    Promise.all([this.voiceInputValidation('title', /^.{1,16}$/),
      this.tax_noInputValidation(),
      this.voiceInputValidation('name', /^.{0,16}$/),
      this.voiceInputValidation('mobile', /^$|^1[34578]\d{9}$/),
      this.voiceInputValidation('address', /^.{0,60}$/),
      this.voiceInputValidation('email', invoiceType === 'electronic' ? /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/ :
        /^$|[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/),
    ]).then((res) => { // 判断表单是否完全输入正确
      this.setState({
        voiceInputValidation: res
      });
      const {invoiceTitle, receipt_shipping_address} = this.state;
      if (invoiceTitle === 'personal') {
        res[1] = true;
      }
      if (res.indexOf(false) === -1) {
        // receipt_shipping_address.title = invoiceTitle === 'personal' ? '个人' : '';
        this.setState({
          invoiceModal: false,
          invoiceData: receipt_shipping_address,
          FinlyInvoiceTitle: invoiceTitle,
          FinlyInvoiceType: invoiceType,
        });
      }
    }).catch(() => {});
  }

  showAgreementModal() { // 显示modal
    this.setState({
      agreementModal: true
    });
  }

  showInvoice() { //  web 发票信息的显示隐藏
    const {webInvoiceDropIcon} = this.state;
    if (webInvoiceDropIcon === 'right') {
      this.setState({
        webInvoiceDropIcon: 'down'
      });
    } else {
      this.setState({
        webInvoiceDropIcon: 'right'
      });
    }
  }

  discountChange(e) { // 优惠券信息的onchage事件
    this.setState({
      discount: e.target.value,
      discountError: false
    });
  }

  useDiscount() { // 使用优惠券
    const {discount, discountUsed} = this.state;
    if (discountUsed) {
      this.setState({
        discountUsed: false,
        discountButton: this.props.t('product_cart_discount_button')
      })
    } else {
      if (discount) {
        client.then((oclient) => { // 请求商品的详细信息
          oclient.apis.coupon.get_coupons_code({
            coupon_code: discount
          }).then((res) => {
            if (res.obj.code !== 200) {
              message.error(res.obj.message);
              this.setState({
                discountUsed: false
              })
            } else {
              this.setState({
                discountPrice: res.obj.data.price,
                discountUsed: true,
                discountButton:  this.props.t('product_cart_discount_button2')
              });
            }
          }).catch(() => message.error(this.props.t('request_error')));
        }).catch(() => message.error(this.props.t('request_error')));
      } else {
        this.setState({
          discountError: true,
          discountUsed: false
        })
      }
    }

  }

  componentWillReceiveProps(nextProps){
    if (this.props.appBarReducer.language !== nextProps.appBarReducer.language) {
      this.setState({
        buttonValue: this.props.t('product_cart_address_verification_button'),
        discountButton: this.props.t('product_cart_discount_button')
      })
    }
  }

  render() {
    const {t} = this.props;
    const dropDownData = [{kye: 'product', name: t('product_cart_product'), icon: 'icon-goods'},
      {key: 'address', name: t('product_cart_address'), icon: 'icon-address'},
      {key: 'statitics', name: t('product_cart_other'), icon: 'icon-invoice'}];
    const headerArr = dropDownData.map((item, index) => (
      <div className="mobile_product_title" key={item.key}>
        {
          item.key === 'statitics' ? '' : <i className={`mobile_product_icon icon iconfont ${item.icon}`} />
        }
        <span className="mobile_product_title_name">{item.name}</span>
        <Icon className="drop_down_icon" type={this.state.dropDownIcon[index]} />
      </div>
    ));
    const {
      productAmount, price, totalPrice, inputValue, notice_mobile, verification_code,
      agreeChecked, buttonDisabled, buttonValue, verificationModal, inputValidation, invoiceModal,
      invoiceTitle, receipt_shipping_address, invoiceType, voiceChecked, voiceInputValidation,
      FinlyInvoiceTitle, FinlyInvoiceType, webInvoiceDropIcon, offsetWidth, discountError, discountPrice, discountButton,
      discountUsed
    } = this.state;
    return (
      <div className="order">
        <div className="web_order">
          <div className="web_shopping_cart_page">
            <div className="web_product_information">
              <div className="web_product_title">
                <i className="web_product_icon icon iconfont icon-goods" />
                <span className="web_product_title_name">{t('product_cart_product')}</span>
              </div>
              <div className="web_product_details">
                <div className="web_order_img">
                  <img src={ImgList.img.productImg[0]} alt="LUBANSO" />
                </div>
                <div className="web_order_details">
                  <div>
                    <p className="web_buy_product_title">{t('product_cart_product_name')}</p>
                    <p className="web_buy_product_details">LUBANSO X1</p>
                  </div>
                  <div>
                    <p className="web_buy_product_title">{t('product_cart_product_price')}</p>
                    <p className="web_buy_product_details theme_color">￥ {price}</p>
                  </div>
                  <div>
                    <p className="web_buy_product_title">{t('product_cart_product_amount')}</p>
                    <div className="web_amount">
                      <div
                        className="web_order_add_one"
                        onClick={() => this.deleteProduct(productAmount)}
                        onKeyPress={() => this.deleteProduct(productAmount)}
                      >
                        <Icon type="minus" />
                      </div>
                      <div className="web_order_total">{productAmount}</div>
                      <div
                        className="web_order_reduction_one"
                        onClick={() => this.addProduct(productAmount)}
                        onKeyPress={() => this.addProduct(productAmount)}
                      >
                        <Icon type="plus" />
                      </div>
                    </div>
                  </div>
                  <div className="web_subtotal_price">
                    <p className="web_buy_product_title">{t('product_cart_product_total_amount')}</p>
                    <p className="web_buy_product_details theme_color">￥ {totalPrice}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="web_address_information">
              <div className="web_address_title">
                <i className="web_address_icon icon iconfont icon-address" />
                <span className="web_address_title_name">{t('product_cart_address')}</span>
              </div>
              <div className="web_address_details">
                <div className="web_address_name">
                  <p className="web_input_error" style={{display: inputValidation.name ? 'none' : 'block'}}>
                    <span className="web_input_label" />{t('product_cart_name_error')}
                  </p>
                  <div className="web_input_label">{t('product_cart_address_name')}</div>
                  <div className={`web_input-text ${(!inputValidation.name && offsetWidth > 768) ? 'input_error' : ''}`}>
                    <Input
                      value={inputValue.name}
                      onChange={e => this.inputInformationOnchange(e, 'name')}
                      style={{borderColor: inputValidation.name ? '#d9d9d9' : '#e4393c' }}
                    />
                  </div>
                </div>
                <div className="web_address_phone">
                  <p className="web_input_error" style={{display: inputValidation.mobile ? 'none' : 'block'}}>
                    <span className="web_input_label" />{t('product_cart_phone_error')}
                  </p>
                  <div className="web_input_label">{t('product_cart_address_phone')}</div>
                  <div className={`web_input-text ${(!inputValidation.mobile && offsetWidth > 768) ? 'input_error' : ''}`}>
                    <Input
                      className="phone_input"
                      style={{borderColor: inputValidation.mobile ? '#d9d9d9' : '#e4393c' }}
                      value={inputValue.mobile}
                      onChange={e => this.inputInformationOnchange(e, 'mobile')}
                    />
                    <i className="icon iconfont icon-icon-test" />
                  </div>
                </div>
                <div className="web_address_verification">
                  <p className="web_input_error" style={{display: inputValidation.verification_code ? 'none' : 'block'}}>
                    <span className="web_input_label" />{t('product_cart_verification_error')}
                  </p>
                  <div className="web_input_label" />
                  <div className={`web_input-text ${(!inputValidation.verification_code && offsetWidth > 768) ? 'input_error' : ''}`}>
                    <Input
                      style={{width: '48%', borderColor: inputValidation.verification_code ? '#d9d9d9' : '#e4393c'}}
                      placeholder={t('product_cart_address_verification_default')}
                      value={verification_code}
                      onChange={e => this.inputVerificationOnchange(e, 'verification_code')}
                    />
                    <Button
                      className={`button_style web_verification_button ${buttonDisabled ? 'disabled_button' : ''}`}
                      onClick={() => this.getVerification()}
                      disabled={buttonDisabled}
                    >
                      {buttonValue}
                    </Button>
                    <Modal
                      title=""
                      style={{ top: 20 }}
                      visible={verificationModal}
                      footer={null}
                      wrapClassName="vertical-center-modal"
                      onCancel={() => this.handleCancel()}
                      closable={false}
                      destroyOnClose={true}
                    >
                      <div id="validation" className="validation nc-container" />
                    </Modal>
                  </div>
                </div>
                <div className="web_address_detailAddress">
                  <p className="web_input_error" style={{display: inputValidation.address ? 'none' : 'block'}}>
                    <span className="web_input_label" />{t('product_cart_address_error')}
                  </p>
                  <div className="web_input_label">{t('product_cart_address_address')}</div>
                  <div className={`web_input-text ${(!inputValidation.address && offsetWidth > 768) ? 'input_error' : ''}`}>
                    <TextArea
                      placeholder={t('product_cart_address_address_default')}
                      autosize={{ minRows: 3, maxRows: 6 }}
                      value={inputValue.address}
                      onChange={e => this.inputInformationOnchange(e, 'address')}
                      style={{borderColor: inputValidation.address ? '#d9d9d9' : '#e4393c' }}
                    />
                  </div>
                </div>
                <div className="web_address_notice">
                  <p className="web_input_error" style={{display: inputValidation.notice_mobile ? 'none' : 'block'}}>
                    <span className="web_input_label" />{t('product_cart_phone_error')}
                  </p>
                  <div className="web_input_label">{t('product_cart_address_delivery')}</div>
                  <div className={`web_input-text ${(!inputValidation.notice_mobile && offsetWidth > 768) ? 'input_error' : ''}`}>
                    <Input
                      className="phone_input"
                      value={notice_mobile}
                      onChange={e => this.inputNoticeMobileOnchange(e)}
                      style={{borderColor: inputValidation.notice_mobile ? '#d9d9d9' : '#e4393c' }}
                    />
                    <i className="icon iconfont icon-icon-test" />
                  </div>
                  <div className="web_address_notice_note">{t('product_cart_address_delivery_notice')}</div>
                </div>
                <div className="web_address_distribution">
                  <div className="web_input_label">{t('product_cart_address_courier')}</div>
                  <div className="web_input-text">
                    {t('product_cart_address_courier_notice')}
                  </div>
                </div>
              </div>
            </div>
            <div className="web_discount_information">
              <div>{t('product_cart_address_courier_notice')}</div>
              <p
                className="web_input_error" style={{display: discountError ? 'block' : 'none'}}>
                {t('product_cart_discount')}
              </p>
              <div>
                <Input
                  placeholder={t('product_cart_discount_default')}
                  onChange={e => this.discountChange(e)}
                  style={{borderColor: discountError ? '#e4393c' : '#d9d9d9' }}
                />
                <Button
                  className="button_style"
                  onClick={() => this.useDiscount() }
                >{discountButton}
                </Button>
              </div>
            </div>
            {
              t('language') === 'zh' ?
                <div className="web_invoice_information">
                  <div
                    className="web_invoice_title"
                    onClick={() => this.showInvoice()}
                    onKeyPress={() => this.showInvoice()}
                  >
                    <span className="web_invoice_title_name">其他选项</span>
                    <Icon className="web_invoice_drop_icon" type={webInvoiceDropIcon} />
                  </div>
                  <div
                    className={`web_invoice_details ${webInvoiceDropIcon === 'down' ? 'web_invoice_gradient_wrapper' : 'web_invoice_gradient_wrapper_two'}`}
                    style={{height: webInvoiceDropIcon === 'right' ? '0' : '44px'}}
                  >
                    <div className="web_invoice_type" style={{display: !voiceChecked ? 'none' : 'inline-block'}}>
                      <span>{FinlyInvoiceTitle === 'personal' ? '个人' : '单位' }</span>
                      <span>{FinlyInvoiceType === 'electronic' ? '电子发票' : '普通发票'}</span>
                      <span
                        className="web_modify_invoice_type"
                        onClick={() => this.invoiceChange()}
                        onKeyPress={() => this.invoiceChange()}
                      >修改<Icon type="right" />
                  </span>
                    </div>
                    <div className="web_invoice_check">
                      <Checkbox
                        checked={voiceChecked}
                        onChange={e => this.invoiceChecked(e)}
                      >我需要发票
                      </Checkbox>
                    </div>
                  </div>
                </div> : false
            }
            <Modal
              title="发票信息"
              style={{ top: 20 }}
              visible={invoiceModal}
              footer={null}
              wrapClassName="vertical-center-modal invoice-modal"
              onCancel={() => this.handleCancel()}
              destroyOnClose={true}
              maskClosable={false}
            >
              <div className="invoice_details">
                <div className="invoice_type invoice_one_type">
                  <div className="invoice_label">发票类型</div>
                  <div className="invoice_one_details invoice_type_details">
                        <span
                          className="invoice_belong invoice_belong_ordinary"
                          onClick={() => this.invoiceType('ordinary')}
                          onKeyPress={() => this.invoiceType('ordinary')}
                          style={{
                            border: invoiceType === 'ordinary' ? '1px solid #6373E8' : '',
                            color: invoiceType === 'ordinary' ? '#6373E8' : ''
                          }}
                        >普通发票
                        </span>
                    <span
                      className="invoice_belong"
                      onClick={() => this.invoiceType('electronic')}
                      onKeyPress={() => this.invoiceType('electronic')}
                      style={{
                        border: invoiceType === 'electronic' ? '1px solid #6373E8' : '',
                        color: invoiceType === 'electronic' ? '#6373E8' : ''
                      }}
                    >电子发票
                        </span>
                  </div>
                </div>
                <div className="invoice_type invoice_one_type">
                  <div className="invoice_label" />
                  <div className="invoice_one_details invoice_type_details">
                    <div className="invoice_type_notice">
                      电子发票是税务机关认可的有效收付款凭证，其法律效力，基本用途及使用规定同纸质发票，可以用于报销入账，售后维权等，
                      电子发票付款完成后会发送至您的邮箱。
                    </div>
                  </div>
                </div>
                <div className="invoice_type invoice_one_type">
                  <div className="invoice_label">发票抬头</div>
                  <div className="invoice_one_details invoice_type_details">
                        <span
                          className="invoice_belong invoice_belong_ordinary"
                          onClick={() => this.invoiceBelong('personal')}
                          onKeyPress={() => this.invoiceBelong('personal')}
                          style={{
                            border: invoiceTitle === 'personal' ? '1px solid #6373E8' : '',
                            color: invoiceTitle === 'personal' ? '#6373E8' : ''
                          }}
                        >个人
                        </span>
                    <span
                      className="invoice_belong"
                      onClick={() => this.invoiceBelong('company')}
                      onKeyPress={() => this.invoiceBelong('company')}
                      style={{
                        border: invoiceTitle === 'company' ? '1px solid #6373E8' : '',
                        color: invoiceTitle === 'company' ? '#6373E8' : ''
                      }}
                    >单位
                        </span>
                  </div>
                </div>
                <div className="invoice_type invoice_one_type">
                  <div className="invoice_label" />
                  <div className="invoice_one_details invoice_type_details">
                    <div
                      className="invoice_input_error"
                      style={{display: voiceInputValidation[0] ? 'none' : 'block'}}
                    >请输入正确的抬头
                    </div>
                    <Input
                      placeholder="请输入发票抬头"
                      value={receipt_shipping_address.title}
                      onChange={e => this.invoiceInputOnChange(e, 'title', 0)}
                      style={{borderColor: voiceInputValidation[0] ? '#d9d9d9' : '#e4393c' }}
                    />
                  </div>
                </div>
                <div
                  className="invoice_type invoice_one_type"
                  style={{
                    display: invoiceTitle === 'company' ? 'block' : 'none',
                  }}
                >
                  <div className="invoice_label">纳税人识别号</div>
                  <div className="invoice_one_details invoice_type_details">
                    <div
                      className="invoice_input_error"
                      style={{display: voiceInputValidation[1] ? 'none' : 'block'}}
                    >请输入正确的纳税号
                    </div>
                    <Input
                      placeholder="请输入税号"
                      value={receipt_shipping_address.tax_no}
                      onChange={e => this.invoiceInputOnChange(e, 'tax_no', 1)}
                      style={{borderColor: voiceInputValidation[1] ? '#d9d9d9' : '#e4393c' }}
                    />
                  </div>
                </div>
                <div className="invoice_type invoice_one_type">
                  <div className="invoice_label">发票内容</div>
                  <div className="invoice_one_details invoice_type_details">
                    购买商品明细
                  </div>
                </div>
                <div className="invoice_type invoice_one_type">
                  <div className="invoice_label">收票人邮箱</div>
                  <div className="invoice_one_details invoice_type_details">
                    <div
                      className="invoice_input_error"
                      style={{display: voiceInputValidation[5] ? 'none' : 'block'}}
                    >请输入正确的邮箱
                    </div>
                    <Input
                      placeholder="收票人邮箱"
                      value={receipt_shipping_address.email}
                      onChange={e => this.invoiceInputOnChange(e, 'email', 5)}
                      style={{borderColor: voiceInputValidation[5] ? '#d9d9d9' : '#e4393c' }}
                    />
                  </div>
                </div>
                <div className="invoice_type invoice_one_type">
                  <div className="invoice_label">收票人姓名</div>
                  <div className="invoice_one_details invoice_type_details">
                    <div
                      className="invoice_input_error"
                      style={{display: voiceInputValidation[2] ? 'none' : 'block'}}
                    >请输入正确的名称
                    </div>
                    <Input
                      placeholder="收票人姓名"
                      value={receipt_shipping_address.name}
                      onChange={e => this.invoiceInputOnChange(e, 'name', 2)}
                      style={{borderColor: voiceInputValidation[2] ? '#d9d9d9' : '#e4393c' }}
                    />
                  </div>
                </div>
                <div className="invoice_type invoice_one_type">
                  <div className="invoice_label">收票人手机号</div>
                  <div className="invoice_one_details invoice_type_details">
                    <div
                      className="invoice_input_error"
                      style={{display: voiceInputValidation[3] ? 'none' : 'block'}}
                    >请输入正确的手机号
                    </div>
                    <Input
                      placeholder="收票人手机号"
                      value={receipt_shipping_address.mobile}
                      onChange={e => this.invoiceInputOnChange(e, 'mobile', 3)}
                      style={{borderColor: voiceInputValidation[3] ? '#d9d9d9' : '#e4393c' }}
                    />
                  </div>
                </div>
                <div
                  className="invoice_type invoice_one_type"
                  style={{display: invoiceType === 'electronic' ? 'none' : 'block'}}
                >
                  <div className="invoice_label">收票人地址</div>
                  <div className="invoice_one_details invoice_type_details">
                    <div
                      className="invoice_input_error"
                      style={{display: voiceInputValidation[4] ? 'none' : 'block'}}
                    >请输入正确的地址
                    </div>
                    <TextArea
                      placeholder="填写详细地址"
                      autosize={{ minRows: 3, maxRows: 6 }}
                      value={receipt_shipping_address.address}
                      onChange={e => this.invoiceInputOnChange(e, 'address', 4)}
                      style={{borderColor: voiceInputValidation[4] ? '#d9d9d9' : '#e4393c' }}
                    />
                  </div>
                </div>
                <div className="invoice_type invoice_one_type">
                  <div className="invoice_label" />
                  <div className="invoice_one_details invoice_type_details">
                    <Button
                      className="voice_cancel"
                      onClick={() => this.invoiceCancel()}
                    >取消
                    </Button>
                    <Button
                      className="voice_submit"
                      onClick={() => this.voiceSubmit()}
                    >保存
                    </Button>
                  </div>
                </div>
              </div>
            </Modal>
            <div className="web_sumit_order">
              <div className="web_order_statistical_information">
                <div>
                  <div>
                    <span>{t('product_cart_statistical_number_before')}{productAmount}{t('product_cart_statistical_number_after')}</span>
                  </div>
                  <div>
                    <span>{t('product_cart_statistical_amount')}</span>
                    <span>{totalPrice}</span>
                  </div>
                  <div>
                    <span>{t('product_cart_statistical_discount')}</span>
                    <span>{discountPrice === 0 ? discountPrice : discountUsed ? `-${discountPrice}` : 0 }</span>
                  </div>
                </div>
                <div>￥ {discountUsed ? totalPrice - discountPrice : totalPrice}</div>
              </div>

              <div>
                <div>
                  <Checkbox onChange={e => this.agreeChecked(e)} /> &nbsp;{t('product_cart_statistical_agreement')}
                  <span
                    className="web_use_term"
                    onClick={() => this.showAgreementModal()}
                    onKeyPress={() => this.showAgreementModal()}
                  >{t('product_cart_statistical_agreement2')}
                  </span>
                </div>
                <div
                  className="web_order_submit_button"
                  onClick={() => this.submitOrder()}
                  onKeyPress={() => this.submitOrder()}
                  style={{
                    background: agreeChecked ? '#0085FF' : 'rgba(0,0,0,0.1)',
                    color: agreeChecked ? '#FFF' : 'rgba(0,0,0,0.4)',
                  }}
                >
                  {t('product_cart_statistical_button')}
                </div>
              </div>
              <AgreementModal
                show={this.state.agreementModal}
                handleCancel={() => this.handleCancel()}
                t={t}
              />
            </div>
          </div>
        </div>
        <div className="mobile_order">
          <div className="mobile_shopping_cart_page">
            <Collapse
              onChange={data => this.panelChange(data)}
              defaultActiveKey={['product', 'address']}
            >
              <Panel className="panel-title" showArrow={false} header={headerArr[0]} key="product">
                <div className="mobile_product_details">
                  <div className="mobile_order_img">
                    <img src={ImgList.img.productImg[0]} alt="LUBANSO" />
                  </div>
                  <div className="mobile_order_details">
                    <p className="mobile_buy_product_details">LUBANSO X1</p>
                    <p className="mobile_buy_product_details theme_color">￥ {price}</p>
                    <div>
                      <div className="mobile_amount">
                        <div
                          className="mobile_order_add_one"
                          onClick={() => this.deleteProduct(productAmount)}
                          onKeyPress={() => this.deleteProduct(productAmount)}
                        >
                          <Icon type="minus" />
                        </div>
                        <div className="mobile_order_total">{productAmount}</div>
                        <div
                          className="mobile_order_reduction_one"
                          onClick={() => this.addProduct(productAmount)}
                          onKeyPress={() => this.addProduct(productAmount)}
                        >
                          <Icon type="plus" />
                        </div>
                      </div>
                    </div>
                    <div className="mobile_subtotal_price">
                      <p className="mobile_buy_product_title">{t('product_cart_product_total_amount')}: </p>
                      <p className="mobile_buy_product_details theme_color">￥ {totalPrice}</p>
                    </div>
                  </div>
                </div>
              </Panel>
              <Panel className="panel-title panel-address-title " showArrow={false} header={headerArr[1]} key="address" disabled={true} >
                <div className="mobile_address_details">
                  <div className="mobile_address_name">
                    <div className="mobile_input_label">{t('product_cart_address_name')}
                      <span
                        style={{display: inputValidation.name ? 'none' : 'block'}}
                        className="web_input_error"
                      >
                        {t('product_cart_name_error')}
                      </span>
                    </div>
                    <div className={`mobile_input-text ${!inputValidation.name ? 'input_error' : ''}`}>
                      <Input
                        value={inputValue.name}
                        onChange={e => this.inputInformationOnchange(e, 'name')}
                        style={{borderColor: inputValidation.name ? '#d9d9d9' : '#e4393c' }}
                      />
                    </div>
                  </div>
                  <div className="mobile_address_phone">
                    <div className="mobile_input_label">{t('product_cart_address_phone')}
                      <span className="web_input_error" style={{display: inputValidation.mobile ? 'none' : 'block'}}> {t('product_cart_phone_error')}</span>
                    </div>
                    <div className={`mobile_input-text ${!inputValidation.mobile ? 'input_error' : ''}`}>
                      <Input
                        className="phone_input"
                        value={inputValue.mobile}
                        onChange={e => this.inputInformationOnchange(e, 'mobile')}
                        style={{borderColor: inputValidation.mobile ? '#d9d9d9' : '#e4393c' }}
                      />
                      <i className="icon iconfont icon-icon-test" />
                    </div>
                  </div>
                  <div className="mobile_address_verification">
                    <p
                      className="web_input_error"
                      style={{display: inputValidation.verification_code ? 'none' : 'block'}}
                    >
                      {t('product_cart_verification_error')}
                    </p>
                    <div className="mobile_input_label" />
                    <div className={`mobile_input-text ${!inputValidation.verification_code ? 'input_error' : ''}`}>
                      <Input
                        style={{width: '50%', borderColor: inputValidation.verification_code ? '#d9d9d9' : '#e4393c'}}
                        placeholder={t('product_cart_address_verification_default')}
                        value={verification_code}
                        onChange={e => this.inputVerificationOnchange(e, 'verification_code')}
                      />
                      <Button
                        className={`button_style mobile_verification_button ${buttonDisabled ? 'disabled_button' : ''}`}
                        onClick={() => this.getVerification()}
                        disabled={buttonDisabled}
                      >
                        {buttonValue}
                      </Button>
                    </div>
                  </div>
                  <div className="mobile_address_detailAddress">
                    <div className="mobile_input_label">{t('product_cart_address_address')}
                      <span className="web_input_error" style={{display: inputValidation.address ? 'none' : 'block'}}> {t('product_cart_address_error')}</span>
                    </div>
                    <div className={`mobile_input-text ${!inputValidation.address ? 'input_error' : ''}`}>
                      <TextArea
                        placeholder={t('product_cart_address_address_default')}
                        autosize={{ minRows: 3, maxRows: 6 }}
                        value={inputValue.address}
                        onChange={e => this.inputInformationOnchange(e, 'address')}
                        style={{borderColor: inputValidation.address ? '#d9d9d9' : '#e4393c' }}
                      />
                    </div>
                  </div>
                  <div className="mobile_address_notice">
                    <div className="mobile_input_label">{t('product_cart_address_delivery')}
                      <span className="web_input_error" style={{display: inputValidation.notice_mobile ? 'none' : 'block'}}> {t('product_cart_phone_error')}</span>
                    </div>
                    <div className={`mobile_input-text ${!inputValidation.notice_mobile ? 'input_error' : ''}`}>
                      <Input
                        className="phone_input"
                        value={notice_mobile}
                        onChange={e => this.inputNoticeMobileOnchange(e)}
                        style={{borderColor: inputValidation.notice_mobile ? '#d9d9d9' : '#e4393c' }}
                      />
                      <i className="icon iconfont icon-icon-test" />
                    </div>
                    <div className="mobile_address_notice_note">{t('product_cart_address_delivery_notice')}</div>
                  </div>
                  <div className="mobile_address_distribution">
                    <div className="mobile_input_label">{t('product_cart_address_courier')}</div>
                    <div className="mobile_input-text">
                      {t('product_cart_address_courier_notice')}
                    </div>
                  </div>
                </div>
              </Panel>
              {
                t('language') === 'zh' ?
                  <Panel className="panel-title invoice_panel" showArrow={false} header={headerArr[2]} key="statitics">
                    <div className="mobile_invoice_details">
                      <div className="mobile_invoice_type" style={{display: !voiceChecked ? 'none' : 'inline-block'}}>
                        <span>{FinlyInvoiceTitle === 'personal' ? '个人' : '单位' }</span>
                        <span>{FinlyInvoiceType === 'electronic' ? '电子发票' : '普通发票'}</span>
                        <span
                          className="mobile_modify_invoice_type"
                          onClick={() => this.invoiceChange()}
                          onKeyPress={() => this.invoiceChange()}
                        >修改<Icon type="right" />
                    </span>
                      </div>
                      <div className="mobile_invoice_check">
                        <Checkbox
                          onChange={e => this.invoiceChecked(e)}
                          checked={voiceChecked}
                        >我需要发票
                        </Checkbox>
                      </div>
                    </div>
                  </Panel> : false
              }
            </Collapse>
            <div className="web_discount_information">
              <div>{t('product_cart_discount')}</div>
              <p
                className="web_input_error" style={{display: discountError ? 'block' : 'none'}}>
                {t('product_cart_discount')}
              </p>
              <div>
                <Input
                  placeholder={t('product_cart_discount_default')}
                  onChange={e => this.discountChange(e)}
                  style={{borderColor: discountError ? '#e4393c' : '#d9d9d9' }}
                />
                <Button
                  className="button_style"
                  onClick={() => this.useDiscount()}
                >{discountButton}
                </Button>
              </div>
            </div>
            <div className="mobile_sumit_order">
              <div className="mobile_order_statistical_information">
                <div><span>{t('product_cart_statistical_number_before')}{productAmount}{t('product_cart_statistical_number_after')}</span></div>
                <div>
                  <span>{t('product_cart_statistical_amount')}</span>
                  <span>{totalPrice}</span>
                </div>
                <div>
                  <span>{t('product_cart_statistical_discount')}</span>
                  <span>{discountPrice === 0 ? discountPrice : discountUsed ? `-${discountPrice}` : 0 }</span>
                </div>
                <div><span>￥ {discountUsed ? totalPrice - discountPrice : totalPrice}</span></div>
              </div>
              <div>
                <div className="mobile_sumit_order_header">
                  <Checkbox onChange={e => this.agreeChecked(e)} />
                  {t('product_cart_statistical_agreement')}
                  <span
                    className="mobile_use_term"
                    onClick={() => this.showAgreementModal()}
                    onKeyPress={() => this.showAgreementModal()}
                  >{t('product_cart_statistical_agreement2')}
                  </span>
                  <span>
                    {t('product_cart_statistical_agreement3')}
                  </span>
                </div>
                <div
                  className="mobile_order_submit_button"
                  onClick={() => this.submitOrder()}
                  onKeyPress={() => this.submitOrder()}
                  style={{
                    background: agreeChecked ? '#0085ff' : 'rgba(0,0,0,0.1)',
                    color: agreeChecked ? '#FFF' : 'rgba(0,0,0,0.4)',
                  }}
                >
                  {t('product_cart_statistical_button')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function select(state) {
  return {
    appBarReducer: state.appBarReducer
  };
}

const ShoppingCartTranslate = translate('translations')(ShoppingCart);

export default connect(select)(ShoppingCartTranslate);

